import { CellContent } from 'shared/types/models/EditMetrics';

export function isInvalidRatioCell(plan: CellContent, fact: CellContent): boolean {
  return (plan === null || +plan === 0) && (fact !== null && +fact > 0);
}
